import { render } from "./MenuBar.vue?vue&type=template&id=6ae508e0&scoped=true"
import script from "./MenuBar.vue?vue&type=script&lang=js"
export * from "./MenuBar.vue?vue&type=script&lang=js"

import "./MenuBar.vue?vue&type=style&index=0&id=6ae508e0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1621785964/src/bitbucket.org/hotelkey/hotelkeyapp.com-v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae508e0"]])

export default __exports__